export default {
    CREATE_DOCUMENT: "Создание документа",
    EDIT_DOCUMENT: "Редактирование документа",
    DUPLICATE_DOCUMENT: "Дублирование документа"
};
